import { Entry } from '../Entry'

export function Entry20230411() {
  return (
    <Entry title="Apr 11 2023 - v3.3.10">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13805/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
